const webhookEventConfig = {
  name: 'Webhook Event',
  endpoint: '/internal_admin/admin_kit/webhook_events',
  modelKey: 'webhook_event',

  columns: [
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'description', title: 'Description' },
    { name: 'event_module', title: 'Module' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[event_module_cont]', label: 'Module' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
    { name: 'event_module', label: 'Module' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'event_module', label: 'Module', type: 'text' },
      {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        required: true,
        rows: 3,
        span: 2,
      },
    ],
  },
};

export default webhookEventConfig;
